import { render } from "./messageContent.vue?vue&type=template&id=2c0c6f0d&scoped=true"
import script from "./messageContent.vue?vue&type=script&lang=js"
export * from "./messageContent.vue?vue&type=script&lang=js"

import "./messageContent.vue?vue&type=style&index=0&id=2c0c6f0d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_T3ED/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0c6f0d"]])

export default __exports__